The organizations the query's access token can act on behalf of.
